import { Dropdown, Menu, Select, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import {
  ActionMenuIcon,
  BinIcon,
  EditAppointmentIcon,
  PlusIcon,
} from 'src/icons';
import { SuperAdminTable } from '../../../baseComponents/Table';
import { Button } from '../../../baseComponents';
import { Form, Formik } from 'formik';
import { Sort } from 'src/icons/Sort.icon';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import {
  getAllPromptsScreens,
  getFilterPrompt,
  getLLmVersiosnsActions,
  getPromptByIdAction,
} from 'src/modules/SuperAdmin/store/actions/prompts.action';
import AddPromptPage from './AddPrompt.page';
import { getAllConditionListAction } from 'src/modules/SuperAdmin/store/actions';
import EditPromptPage from './EditPrompt.page';
import DeletePrompt from './DeletePrompt';

const Promptspage = () => {
  const dispatch = useDispatch();
  const { getAllPromptsList } = useSelector((state) => state?.promptsState);
  const { getAllConditionsList, isLoading, conditionsDropdown } = useSelector(
    (state) => state?.conditionState
  );
  const [conditionOptions, setConditionOptions] = useState([]);
  const [specialtyOptions, setSpecialtyOptions] = useState([]);
  const [selectedSpecialty, setSelectedSpecialty] = useState(null);
  const [selectedCondition, setSelectedCondition] = useState(null);
  const [tableLoader, setTableLoader] = useState(false);
  const [tableData, setTableData] = useState(null);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  useEffect(() => {
    dispatch(getFilterPrompt(null, null));
    dispatch(getAllConditionListAction());
    dispatch(getLLmVersiosnsActions());
    dispatch(getAllPromptsScreens());
  }, [dispatch]);

  useEffect(() => {
    setTableLoader(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (
      getAllPromptsList &&
      Array.isArray(getAllPromptsList) &&
      getAllPromptsList.length > 0
    ) {
      let dataArray = getAllPromptsList?.map((list, index) => {
        return {
          key: index,
          prompt_id: list?.prompt_id,
          prompt_name: list?.prompt ? list?.prompt : 'N/A',
          description: list?.description ? list?.description : 'N/A',
          condition_name: list?.condition_name ? list?.condition_name : 'N/A',
          specialty_name: list?.specialty_name ? list?.specialty_name : 'N/A',
        };
      });
      if (dataArray && Array.isArray(dataArray) && dataArray.length > 0) {
        setTableData(dataArray);
      }
    } else {
      setTableData([]);
    }
  }, [getAllPromptsList]);

  useEffect(() => {
    if (conditionsDropdown && Array.isArray(conditionsDropdown)) {
      let dataArr = [];
      conditionsDropdown.forEach((key) => {
        dataArr.push({
          value: key?.condition_id,
          label: key?.condition_name,
        });
      });
      dataArr?.unshift({ label: 'All', value: 'All' });
      setConditionOptions(dataArr);
    }
  }, [conditionsDropdown]);

  useEffect(() => {
    if (conditionsDropdown && Array.isArray(conditionsDropdown)) {
      const uniqueSpecialtyIds = {};
      const dataArr = [];
      conditionsDropdown.forEach((key) => {
        if (!uniqueSpecialtyIds[key.specialty_id]) {
          uniqueSpecialtyIds[key.specialty_id] = true;
          dataArr.push({
            value: key?.specialty_id,
            label: key?.specialty_name ? key?.specialty_name : 'N/A',
          });
        }
      });
      dataArr?.unshift({ label: 'All', value: 'All' });
      setSpecialtyOptions(dataArr);
    }
  }, [conditionsDropdown, getAllConditionsList]);

  const handleEditOpen = (prompt_id) => {
    dispatch(getPromptByIdAction(prompt_id, setEditModalOpen));
  };

  const handleDeleteOpen = (prompt_id) => {
    dispatch(getPromptByIdAction(prompt_id, setDeleteModalOpen));
  };

  const menu_options = (id, record) => {
    return (
      <Menu
        onClick={({ key }) => {
          if (key === 'editPrompt') {
            handleEditOpen(id);
          }
          if (key === 'deletePrompt') {
            handleDeleteOpen(id, record);
          }
        }}
      >
        <Menu.Item key="editPrompt">
          <div className="dropdown-text flex items-center space-x-2">
            <EditAppointmentIcon /> <span>Edit prompt</span>
          </div>
        </Menu.Item>
        <Menu.Item key="deletePrompt">
          <div className="dropdown-text flex items-center space-x-2">
            <BinIcon /> <span>Remove prompt</span>
          </div>
        </Menu.Item>
      </Menu>
    );
  };

  const condition_nameSorter = (a, b) => {
    return a.condition_name.localeCompare(b.condition_name);
  };

  const description_Sorter = (a, b) => {
    return a.description.localeCompare(b.description);
  };

  const columns = [
    {
      title: <span className="font-[700]"> Prompt </span>,
      dataIndex: 'prompt_name',
      key: 'prompt_name',
      render: (text) => {
        const textLength = text.length > 100;
        const tooltipContent = (
          <div
            className={`${textLength ? 'flex w-[495px] overflow-auto whitespace-normal h-56 p-2' : ''}`}
          >
            {text}
          </div>
        );
        return (
          <>
            <Tooltip
              title={tooltipContent}
              placement={textLength ? 'right' : 'top'}
            >
              <div className="truncate w-56">{text}</div>
            </Tooltip>
          </>
        );
      },
    },
    {
      title: (
        <span className="font-[700]">
          {' '}
          Description{' '}
          {tableData?.length > 0 && <Sort className={'sort-icon-doctor'} />}
        </span>
      ),
      dataIndex: 'description',
      key: 'description',
      sorter: tableData?.length > 0 && description_Sorter,
    },
    {
      title: (
        <span className="font-[700]">
          {' '}
          Condition{' '}
          {tableData?.length > 0 && <Sort className={'sort-icon-doctor'} />}
        </span>
      ),
      dataIndex: 'condition_name',
      key: 'condition_name',
      sorter: tableData?.length > 0 && condition_nameSorter,
    },
    {
      title: <span className="font-[700]"> Specialty</span>,
      dataIndex: 'specialty_name',
      key: 'specialty_name',
    },
    {
      title: '',
      key: 'actions',
      dataIndex: 'actions',
      render: (text, record) => {
        return (
          <Dropdown
            className=""
            overlay={menu_options(record?.prompt_id, record)}
          >
            <a className="" onClick={(e) => e.preventDefault()}>
              <ActionMenuIcon />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const initialFilterValue = {
    specialty_id: null,
    condition_id: null,
  };

  const [filterValue, setFilterValue] = useState(initialFilterValue);

  const filterHandler = (type, value) => {
    if (type === 'specialty') {
      setSelectedSpecialty(value === 'All' ? null : value);
      if (value === 'All') {
        setFilterValue({
          ...filterValue,
          specialty_id: null,
        });
        if (filterValue?.condition_id === null) {
          dispatch(getFilterPrompt());
        } else {
          dispatch(getFilterPrompt(null, filterValue?.condition_id));
        }
      } else {
        setFilterValue({
          ...filterValue,
          specialty_id: value,
        });
        dispatch(getFilterPrompt(value, filterValue?.condition_id));
      }
    } else {
      setSelectedCondition(value === 'All' ? null : value);
      if (value === 'All') {
        setFilterValue({
          ...filterValue,
          condition_id: null,
        });
        if (filterValue?.specialty_id === null) {
          dispatch(getFilterPrompt());
        } else {
          dispatch(getFilterPrompt(filterValue?.specialty_id, null));
        }
      } else {
        setFilterValue({
          ...filterValue,
          condition_id: value,
        });
        dispatch(getFilterPrompt(filterValue?.specialty_id, value));
      }
    }
  };

  return (
    <>
      <div>
        <Formik>
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <div className="flex flex-col sm:flex-row lg:justify-between items-center gap-4">
                <div className="flex flex-col sm:flex-row w-full">
                  <div className="flex justify-start gap-6 w-full">
                    <div className="  bg-white shadow-sm rounded-xl w-3/5 flex items-center practitioner-dropdown">
                      <Select
                        style={{
                          placeholder: {
                            fontFamily: 'Poppins',
                            color: '#667085',
                          },
                        }}
                        bordered={false}
                        className="border-none font-sans h-10 flex items-center focus:outline-none w-full"
                        optionFilterProp="label"
                        placeholder="Search condition"
                        showSearch
                        options={conditionOptions}
                        onChange={(e) => filterHandler('condition', e)}
                        value={filterValue.condition_id}
                        id="Prompt_condition_id"
                      ></Select>
                    </div>
                    <div className="bg-white shadow-sm rounded-xl w-2/5 flex items-center">
                      <Select
                        style={{
                          placeholder: {
                            fontFamily: 'Poppins',
                            color: '#667085',
                          },
                        }}
                        bordered={false}
                        className="border-none font-sans h-10 flex items-center focus:outline-none w-full"
                        optionFilterProp="label"
                        placeholder="Search specialty"
                        showSearch
                        options={specialtyOptions}
                        onChange={(e) => filterHandler('specialty', e)}
                        value={filterValue.specialty_id}
                        id="Prompt_specialty_id"
                      ></Select>
                    </div>
                  </div>
                </div>
                <div className="flex justify-end items-end">
                  <Button
                    type={'button'}
                    onClick={() => setAddModalOpen(true)}
                    className="w-36"
                  >
                    <PlusIcon className={`mr-2`} /> Add prompt
                  </Button>
                </div>
              </div>
              <div className="mt-5 ant-table rounded-xl shadow-xl">
                <SuperAdminTable
                  className={`appointment-page-table`}
                  columns={columns}
                  data={tableData}
                  loading={tableLoader}
                />
              </div>
              {/* Modal open here : Start */}
              <AddPromptPage
                isOpen={addModalOpen}
                setIsOpen={setAddModalOpen}
                selectedSpecialty={selectedSpecialty}
                selectedCondition={selectedCondition}
              />

              <EditPromptPage
                isOpen={editModalOpen}
                setIsOpen={setEditModalOpen}
                selectedSpecialty={selectedSpecialty}
                selectedCondition={selectedCondition}
              />

              <DeletePrompt
                isOpen={deleteModalOpen}
                setIsOpen={setDeleteModalOpen}
                selectedSpecialty={selectedSpecialty}
                selectedCondition={selectedCondition}
              />
              {/* Ends */}
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default Promptspage;
